import { createSlice } from '@reduxjs/toolkit';

import { ChartCreationMethod } from '@DStypes/chart';
export interface DataState {
  id: string;
  chart_title: string;
  chart_project: string;
  chart_short_desc: string;
  chart_long_desc: string;
  is_deleted: boolean;
  chart_reports: null[] | null;
  has_edited_title: boolean;
  config: any;
  chart_project_name: string;
  chart_project_auto_charts_executed: boolean;
  created_by_auto_charts: boolean;
  newConfig: any;
  chartMatrix: any;
  project_colorset: string[] | null;
  colorset: string[] | null;
  rating: number;
  method_used: ChartCreationMethod;
  chart_config_count: number;
  chart_insights: any;
  openInsights: boolean;
}

const initialState: DataState = {
  id: '',
  chart_title: '',
  chart_project: '',
  chart_short_desc: '',
  chart_long_desc: '',
  is_deleted: false,
  chart_reports: [],
  has_edited_title: false,
  config: {},
  chart_project_name: '',
  chart_project_auto_charts_executed: false,
  created_by_auto_charts: false,
  newConfig: {},
  chartMatrix: {},
  project_colorset: null,
  colorset: null,
  rating: 0,
  method_used: null,
  chart_config_count: 0,
  chart_insights: {},
  openInsights: false
};

export const currentChartData = createSlice({
  name: 'currentChartData',
  initialState,
  reducers: {
    setChartData: (state, { payload }) => ({ ...state, ...payload }),
    updateConfig: (state, { payload }) => {
      const data = { ...state.config, [payload.field]: payload.value };

      return { ...state, config: data };
    },
    updateNewConfig: (state, { payload }) => ({ ...state, newConfig: payload }),
    setChartMatrix: (state, { payload }) => ({
      ...state,
      chartMatrix: payload
    }),
    setChartInsights: (state, { payload }) => ({
      ...state,
      chart_insights: {
        ...state.chart_insights,
        ...payload
      }
    }),
    setChartShortDescription: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    setOpenInsights: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    resetChartConfigData: () => initialState
  }
});

export const {
  setChartData,
  updateConfig,
  updateNewConfig,
  setChartMatrix,
  resetChartConfigData,
  setChartInsights,
  setChartShortDescription,
  setOpenInsights
} = currentChartData.actions;

export default currentChartData.reducer;
